<template>
    <div class="growth-predict-block">
        
        <div :id="chartID" class="chart-growth-predict"></div>

        <div v-if="clickedStage">
            {{ clickedStage }}
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import ecTools from '@/echarts/echarts-tools'

export default {
    props:
    {
        chartID: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            default: function () { return {} }
        },
        time: {
            type: Array,
            default: function () { return [] }
        },
        showToolbox: {
            type: Boolean,
            default: true,
        },
        xAxisName: { type: String, },
        yAxisName: { type: String, },
        xAxisFormat: {
            type: String,
            default: 'MM/DD HH:mm',
        },
    },
    data () {
        return {
            theChart: undefined,
            clickedStage: undefined,
        }
    },
    mounted ()
    {
        this.theChart = echarts.init(document.getElementById( this.chartID ));
        this.drawChartPrepare();
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'screenWidth': state => state.system.screenWidth,
            'contentWidth': state => state.system.contentWidth,
        }),
    },
    watch: {
        // 偵測到 [ 語言 ] 變動就更新圖表
        language ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 時間 ] 變動就更新圖表
        time ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 視窗寬度 ] 變動就更新圖表
        screenWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
        // 偵測到 [ 版面寬度 ] 變動就更新圖表
        contentWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
    },
    methods: {

        arrange_DataSet ()
        {
            let _data = this.data
            let _stage_days = [], _predict_days = []

            /**
             * 處理生長期資料
             */
            let _stageSet = []
            _data['growth_predict'].forEach( _stage => {
                let _start = this.$moment( _stage.start_date ).format('YYYY-MM-DD')
                let _end = this.$moment( _stage.end_date ).format('YYYY-MM-DD')

                // [ 開始日期, 結束日期, y 軸高度, 生長期名稱, 是否為預測值 ]
                _stageSet.push([ _start, _end, 100, _stage.name[ this.language ], false, ])
                if ( _stage_days.indexOf( _start ) == -1 ) _stage_days.push( _start )
                if ( _stage_days.indexOf( _end ) == -1 )   _stage_days.push( _end )
            })


            
            /**
             * 處理目前進度
             */
            let _predictSet = []
            let _start_current = this.$moment( _data.progress.start_date ).format('YYYY-MM-DD')
            let _end_current   = this.$moment( _data.progress.end_date ).format('YYYY-MM-DD')

            // [ 開始日期, 結束日期, y 軸高度, 生長期名稱, 是否為預測值 ]
            _predictSet.push([ _start_current, _end_current, 2, this.$t('menu.crop_growth_progress'), false ])
            if ( _predict_days.indexOf( _start_current ) == -1 ) _predict_days.push( _start_current )
            if ( _predict_days.indexOf( _end_current ) == -1 )   _predict_days.push( _end_current )



            /**
             * 處理收穫預測
             */
            let _start_predict = this.$moment( _data.harvest_range.min_harvest_date ).format('YYYY-MM-DD')
            let _end_predict   = this.$moment( _data.harvest_range.max_harvest_date ).format('YYYY-MM-DD')

            // [ 開始日期, 結束日期, y 軸高度, 生長期名稱, 是否為預測值 ]
            // _stageSet.push([ _start_predict, _end_predict, 3, this.$t('menu.harvest_prediction'), true ])

            // if ( _stage_days.indexOf( _start_predict ) == -1 ) _stage_days.push( _start_predict )
            // if ( _stage_days.indexOf( _end_predict ) == -1 )   _stage_days.push( _end_predict )

            // [ 開始日期, 結束日期, y 軸高度, 生長期名稱, 是否為預測值 ]
            _predictSet.push([ _start_predict, _end_predict, 2, this.$t('menu.harvest_prediction'), true ])
            if ( _predict_days.indexOf( _start_predict ) == -1 ) _predict_days.push( _start_predict )
            if ( _predict_days.indexOf( _end_predict ) == -1 )   _predict_days.push( _end_predict )



            /**
             * 處理建議工作
             */
            let _workSet = []
            _data['work_advice'].forEach( (_work, _idx) => {
                let _start = this.$moment( _work.date ).format('YYYY-MM-DD')
                let _yValue = ( _idx % 2 == 0 ? 1 : 2 )

                // [ 日期, 生長期名稱, y 軸高度(跟隔壁生長期高度錯開), 建議工作 ]
                _workSet.push([ _start, '', _yValue, _work.advice_work.join(',') ])
            })

            return {
                stages: _stageSet,
                predicts: _predictSet,
                works: _workSet,

                stage_days: _stage_days,
                predict_days: _predict_days,
                
                min_date: this.$moment( _data.min_date ).add(-1, 'days').format('YYYY-MM-DD'),
                max_date: this.$moment( _data.max_date ).add(2, 'days').format('YYYY-MM-DD'),

                daily_progress: _data['daily_progress'],
            }
        },

        arrange_ChartData (_dataSet)
        {
            let _this = this
            let _stageSet = _dataSet.stages
            let _predictSet = _dataSet.predicts
            let _workSet = _dataSet.works
            let _colorList = ['#46b981', '#63cf75', '#9ae085', '#beed78', '#ffdb4d', '#ffa64d', '#ce9464', '#d0a892', '#a27676', '#9999ff'];
            // let _colorList = ['#d5f06f', '#29e3c7', '#2ab3bd', '#b9a8f2', '#f9a7b3', '#ff8080', '#e46c0b'];

            _stageSet = echarts.util.map( _stageSet, function (item, index) {
                let _is_predict = item[4]

                return {
                    value: item,
                    itemStyle: {
                        color: ( _is_predict ? 'rgba(255, 128, 128, 0.8)' : _colorList[ index ] ),
                        borderWidth: ( _is_predict ? 1 : 0 ),
                        borderColor: ( _is_predict ? '#fff' : null ),
                    }
                };
            });

            _predictSet = echarts.util.map( _predictSet, function (item, index) {
                let _is_predict = item[4]

                return {
                    value: item,
                    itemStyle: {
                        color: ( _is_predict ? '#ff3377' : '#005c99' ),
                    }
                };
            });
            
            _workSet = echarts.util.map( _workSet, function (item, index) {
                let _is_predict = item[4]
                let _color = '#999999'

                // 判斷在哪個生長期內
                _stageSet.forEach( _stage => {

                    if ( _this.$moment( item[0] ).isSameOrAfter( _stage.value[0] ) )
                    {
                        _color = _stage.itemStyle.color
                        item[1] = _stage.value[3]
                    }
                })

                return {
                    value: item,
                    itemStyle: {
                        color: _color,
                    }
                };
            });

            // 錯開相同生長期的高度
            if ( _workSet.length > 1 )
            {
                for (let i=1; i<_workSet.length; i++)
                {
                    if ( _workSet[ i ].value[1] == _workSet[ i-1 ].value[1] )
                    {
                        _workSet[ i ].value[2] = _workSet[ i-1 ].value[2] + 1
                    }
                }
            }

            return {
                stages: _stageSet,
                predicts: _predictSet,
                works: _workSet,

                stage_days: _dataSet.stage_days,
                predict_days: _dataSet.predict_days,
                
                min_date: _dataSet.min_date,
                max_date: _dataSet.max_date,

                daily_progress: _dataSet['daily_progress'],
            }

        },

        drawChartPrepare ()
        {
            // if (this.data && this.data.length > 0) {

                this.drawChart( this.theChart,
                                this.data,
                                this.time,
                                this.showToolbox,
                                [ this.xAxisName, this.yAxisName ] );
            // }
        },
        
        drawChart ( chart,
                    _data,
                    _time,
                    _showToolbox,
                    _axisName )
        {

            let _this = this;
            let _xAxisName = ( _axisName[0] ? this.$t('u.'+_axisName[0]) : '');
            let _yAxisName = ( _axisName[1] ? this.$t('u.'+_axisName[1]) : '' );

            let _dataSet = this.arrange_DataSet()

            let _chartData = this.arrange_ChartData(_dataSet)
            let _stageSet = _chartData.stages
            let _predictSet = _chartData.predicts
            let _workSet = _chartData.works
            let _stage_days = _chartData.stage_days;
            let _predict_days = _chartData.predict_days;
            let _daily_progress = _chartData.daily_progress;


            let option = {
                title: {
                    text: '生長期預測 Growth Period Prediction',
                    left: 'center',
                },
                tooltip: {
                    backgroundColor: 'rgba(245, 245, 245, 0.9)',
                    borderWidth: 1,
                    borderColor: '#ccc',
                    padding: 10,
                    textStyle: {
                        color: '#000'
                    },
                    // formatter: function (params) {
                    //     console.log( params )
                    //     return params
                    // },
                 /*   
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                    },
                    position: function (pos, params, el, elRect, size) {
                        var obj = {top: 10};
                        obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                        return obj;
                    },
                */
                ///*
                    formatter: function (params) {
                        // console.log( params )
                        let _stageInfo = '', _workInfo = '', _predictInfo = ''


                        let _createTooltip = function (_data, is_array = false) {
                            if ( _data.seriesName == 'works' && _data.axisDim != 'y' ) // work
                            {
                                if ( is_array ) _workInfo += '<br><br>'
                                _workInfo += `<i class="fa fa-circle" style="color:${ _data.color }"></i> ${ _data.value[0] }<br>
                                建議工作：${ _data.name }
                                `
                            }
                            if ( _data.seriesName == 'growth_stages' ) // stage
                            {
                                let _is_first = false
                                if ( _stageInfo == '' ) _is_first = true

                                _stageInfo += `<i class="fa fa-circle" style="color:${ _data.color }"></i>
                                ${ _data.name }<br>
                                日期範圍：${ _data.value[0] } - ${ _data.value[1] }
                                `

                                if ( _is_first && is_array ) _stageInfo += '<br><br>'
                            }
                            if ( _data.seriesName == 'progress' ) // stage
                            {
                                _predictInfo += `<i class="fa fa-circle" style="color:${ _data.color }"></i>
                                ${ _data.name }<br>
                                日期範圍：${ _data.value[0] } - ${ _data.value[1] }
                                `
                            }
                        }

                        if ( Array.isArray( params ) )
                        {
                            params.forEach( _data => {
                                _createTooltip( _data, true )
                            })
                        }
                        else
                        {
                            _createTooltip( params )
                        }

                        return _stageInfo + _predictInfo + _workInfo
                    },
                    //*/
                    // extraCssText: 'width: 170px'
                },
                /*
                axisPointer: {
                    show: true,
                    // type: 'line',
                    // snap: true,
                    link: [{
                        xAxisIndex: 'all',
                    }],
                    label: {
                        show: false,
                        backgroundColor: '#666',
                        formatter: function (params) {
                            // console.log( params )

                            // 有 seriesData 資料的為 x 軸取得的資料，將 params.value 轉換為日期
                            if ( params && params.seriesData && params.seriesData.length > 0 )
                            {
                                return _this.$moment(params.value).format('YYYY-MM-DD');
                            }
                            else // 此為 y 軸資料
                            {
                                return null
                            }
                        },
                    },
                },
                */
                grid: [
                    {
                        top: '10%',
                        left: 30,
                        right: 20,
                        height: '28%'
                    },
                    {
                        left: 30,
                        right: 20,
                        top: '51%',
                        height: '3%'
                    },
                    {
                        left: 30,
                        right: 20,
                        top: '55%',
                        height: '30%'
                    },
                ],
                xAxis: [
                    {
                        gridIndex: 0,
                        type: 'time',
                        // scale: true,
                        boundaryGap: 0,
                        min: _dataSet.min_date,
                        max: _dataSet.max_date,
                        // axisTick: {
                        //     show: false,
                        //     interval: 10,
                        // },
                        // splitNumber: 20,
                        interval: 3600 * 24 * 1000, // 切分為每天一格
                        axisLabel: {
                            show: true,
                            interval: 0,
                            fontSize: 10,
                            formatter: function (value){
                                // console.log( value )
                                let _date = _this.$moment(value).format('YYYY-MM-DD')
                                // console.log( _date )
                                // console.log( _stage_days.indexOf( _date ) )
                                if ( _stage_days.indexOf( _date ) != -1 )
                                {
                                    return _this.$moment(_date).format('MM-DD') + '\n' + _this.$moment(_date).format('YYYY')
                                }
                                return ''
                            },
                        },
                        axisTick: { show: false },
                        splitLine: { show: false },
                    },
                    {
                        gridIndex: 1,
                        show: true,
                        type: 'time',
                        // scale: true,
                        boundaryGap: 0,
                        min: _dataSet.min_date,
                        max: _dataSet.max_date,
                        interval: 3600 * 24 * 1000, // 切分為每天一格
                        axisLabel: {
                            show: true,
                            interval: 0,
                            fontSize: 10,
                            formatter: function (value){
                                let _date = _this.$moment(value).format('YYYY-MM-DD')
                                if ( _predict_days.indexOf( _date ) != -1 )
                                {
                                    return _this.$moment(_date).format('MM-DD') + '\n' + _this.$moment(_date).format('YYYY')
                                }
                                return ''
                            },
                        },
                        axisTick: { show: false },
                        splitLine: { show: false },
                    },
                    {
                        gridIndex: 2,
                        show: false,
                        type: 'time',
                        // scale: true,
                        boundaryGap: 0,
                        min: _dataSet.min_date,
                        max: _dataSet.max_date,
                    },
                ],
                yAxis: [
                    {
                        name: '阿龜預測',
                        gridIndex: 0,
                        show: false,
                    },
                    {
                        gridIndex: 1,
                        show: true,
                        name: '生長狀況',
                        nameLocation: 'middle',
                        nameGap: 8,
                        axisLabel:  { show: false },
                        axisLine:   { show: false },
                        axisTick:   { show: false },
                        splitLine:  { show: false }
                    },
                    {
                        gridIndex: 2,
                        show: true,
                        inverse: true,
                        name: '建議工作',
                        nameLocation: 'middle',
                        nameGap: 8,
                        min: 0,
                        // max: 30,
                        axisLabel:  { show: false },
                        axisLine:   { show: false },
                        axisTick:   { show: false },
                        splitLine:  { show: false }
                    },
                ],
                series: [
                    {
                        type: 'custom',
                        name: 'growth_stages',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        renderItem: this.render_Stages,
                        label: {
                            show: true,
                            color: '#000',
                            textBorderColor: 'rgba(255,255,255,0.5)',
                            textBorderWidth: 3,
                            position: 'inside',
                            formatter: function (params) {
                                let _name = ( _this.screenWidth > 800 ? params.name : params.name.slice(0,2) )
                                
                                return _name //+ '\n'
                            },
                        },
                        dimensions: ['start date', 'end date', null, 'stage', 'is predict'],
                        encode: {
                            x: [0, 1],
                            y: 2,
                            tooltip: [0, 1, 3],
                            itemName: 3,
                            value: 3,
                        },
                        data: _stageSet,
                        animation: true,
                        animationDuration: 5000,
                        animationDelay: function (idx) { return idx * 10; },
                    },
                    {
                        type: 'line',
                        name: 'progress_percent_line',
                        xAxisIndex: 0,
                        yAxisIndex: 0,
                        name: 'MA5',
                        data: _daily_progress,
                        smooth: true,
                        symbol: 'none',
                        lineStyle: {
                            type: 'dash',
                            color: '#000',
                            opacity: 0.6,
                        }
                    },
                    {
                        type: 'custom',
                        name: 'progress',
                        xAxisIndex: 1,
                        yAxisIndex: 1,
                        renderItem: this.render_Stages,
                        label: {
                            show: true,
                            color: '#000',
                            textBorderColor: 'rgba(255,255,255,0.5)',
                            textBorderWidth: 3,
                            position: 'top',
                            formatter: function (params) {
                                let _name = ( _this.screenWidth > 800 ? params.name : params.name.slice(0,2) )
                                
                                return _name //+ '\n'
                            },
                        },
                        dimensions: ['start date', 'end date', null, 'stage', 'is predict'],
                        encode: {
                            x: [0, 1],
                            y: 2,
                            tooltip: [0, 1, 3],
                            itemName: 3,
                            value: 3,
                        },
                        data: _predictSet,
                        animation: true,
                        animationDuration: 5000,
                        animationDelay: function (idx) { return idx * 10; },
                    },
                    {
                        type: 'scatter',
                        name: 'progress icon',
                        xAxisIndex: 1,
                        yAxisIndex: 1,
                        symbol: 'image://' + this.$config.getAssetsURL('img/brand/AgriChartSymbol01.png'),//'arrow',
                        // symbolRotate: -90,
                        symbolSize: 70,
                        dimensions: ['date', null, 'name'],
                        encode: {
                            x: 0,
                            y: 1,
                            tooltip: [0, 2],
                            itemName: 2,
                            value: 0,
                        },
                        itemStyle: {
                            opacity: 1,
                        },
                        data: [
                            [ _predictSet[0].value[1], 1 ]
                        ],
                        animation: true,
                        animationDuration: 5000,
                        animationDelay: function (idx) { return idx * 10; },
                    },
                    {
                        type: 'scatter',
                        name: 'works',
                        xAxisIndex: 2,
                        yAxisIndex: 2,
                        label: {
                            show: true,
                            color: '#000',
                            fontSize: 12,
                            position: 'right',
                            formatter: function (params) {
                                if ( _this.screenWidth > 800 ) return _this.$moment( params.value[0] ).format('MM/DD') + ' ' + params.name
                                return params.name.slice(0,2)// + '\n 123'
                            },
                        },
                        itemStyle: {
                            color: '#8dd4b2',
                        },
                        symbolSize: 12,
                        dimensions: ['date', 'stage', 'index', 'work'],
                        encode: {
                            x: 0,
                            y: 2,
                            tooltip: [0, 1, 3],
                            itemName: 3,
                            value: 3,
                        },
                        data: _workSet,
                        animation: true,
                        animationDuration: 5000,
                        animationDelay: function (idx) { return idx * 10; },
                    },
                    
                ]
            };
            chart.setOption(option);

            chart.on('click', function (params) {
                // console.log( params.name )
                // _this.clickedStage = 'clicked ' + params.name
            });
        },

        render_Stages (params, api) {
            let yValue = api.value(2);
            let start = api.coord([api.value(0), yValue]);
            let size = api.size([api.value(1) - api.value(0), yValue]);
            let style = api.style();

            return {
                type: 'rect',
                shape: {
                    x: start[0],
                    y: start[1],
                    width: size[0],
                    height: size[1]
                },
                style: style
            };
        },

    },
}
</script>

<style lang="scss" scoped>

.growth-predict-block
{
    overflow-x: auto;
}

.chart-growth-predict
{
    width: 100%;
    min-width: 1100px;
    height: 400px;
}

</style>